import { render, staticRenderFns } from "./home.vue?vue&type=template&id=57909e4b"
import script from "./home.ts?vue&type=script&lang=js&external"
export * from "./home.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports